import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';

import { MAP_RESOURCE } from '@/assets';
import { APP_VERSION } from '@/configs/version';
import { SectionContent } from '@/features/start/components/components/SectionContent';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { TabRoute } from '@/navigation/types/navigation';
import { EmbeddedWebpage } from '@/shared/components/embedded/EmbeddedWebpage';

const styles = StyleSheet.create({
  webViewContainer: {
    maxHeight: 160,
    height: 160,
    overflow: 'hidden',
    borderRadius: 12
  }
});

type Props = {
  url?: string;
};

export const WebviewSection: FC<Props> = ({ url }) => {
  const { t } = useTranslation(LocalizationNameSpace.START, {
    keyPrefix: 'screens.start.sections.region'
  });

  return (
    <SectionContent title={t('focus')} screen={TabRoute.Region}>
      <View style={styles.webViewContainer}>
        <EmbeddedWebpage
          srcId={MAP_RESOURCE}
          src={url}
          onError={(e) => console.error(e.target)}
          openLinksExtern
          userAgentPostfix={`StadtLandFunk/${APP_VERSION}`}
          preventScroll
        />
      </View>
    </SectionContent>
  );
};
